import classes from "./SearchType.module.css";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import useDelayUnmount from "../../../hooks/useDelayUnmount";
import { useState } from "react";
import MultiLanTxt from "../../UI/MultiLanTxt/MultiLanTxt";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const SearchType = ({ setSearchTypes, name, searchTypes, forceLtr }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const showMenu = useDelayUnmount(openMenu, 250);

  const handleChange = (e) => {
    setSearchTypes((ps) => ({ ...ps, [name]: e.target.value }));
  };

  return (
    <>
      {openMenu ? <div className={classes.bckdrp} onClick={(e) => setOpenMenu(false)} /> : null}
      <span className={classes.searchTypeSpan}>
        <MoreVertIcon className={classes.moreIcon} onClick={(e) => setOpenMenu(true)} />
        {showMenu ? (
          <div
            className={[classes.menuContainer, openMenu ? classes.mounted : classes.unmounted].join(" ")}
          >
            <RadioGroup value={searchTypes[name]} onChange={handleChange}>
              <FormControlLabel
                value="include"
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 20,
                      },
                    }}
                  />
                }
                label={forceLtr ? "Includes" : <MultiLanTxt tid="INCLUDE_SEARCH" />}
                sx={{
                  margin: "0px !important",
                  fontSize: "14px",
                  "& .MuiTypography-root": {
                    fontSize: 14,
                    color: "#5a5a5a",
                  },
                }}
              />
              <FormControlLabel
                value="exact"
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 20,
                      },
                    }}
                  />
                }
                label={forceLtr ? "Exact" : <MultiLanTxt tid="EXACT_SEARCH" />}
                sx={{
                  margin: "0px !important",
                  fontSize: "14px",
                  "& .MuiTypography-root": {
                    fontSize: 14,
                    color: "#5a5a5a",
                  },
                }}
              />
            </RadioGroup>
          </div>
        ) : null}
      </span>
    </>
  );
};

export default SearchType;
